export const getEnvVar = (key) => {
  return process.env[`REACT_APP_${key}`] || "";
};
